import { Injectable } from '@angular/core';
import { ChatMessageAuthor } from '@root/shared/chat';
import { ApiService } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { delay, Observable, of } from 'rxjs';
import { Feedback, FeedbackAdminResp, FeedbackStatus } from './feedback.abstraction';

@Injectable()
export class FeedbackApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getFeedback(feedbackId: number): Observable<Feedback> {
    return of({
      id: feedbackId,
      botId: 1,
      adminUserEmail: null,
      status:
        feedbackId % 3 === 0
          ? FeedbackStatus.InProgress
          : feedbackId % 2 === 0
          ? FeedbackStatus.New
          : FeedbackStatus.Processed,
      receivedAt: new Date().toISOString(),
      items: [
        {
          id: 1,
          author:
            feedbackId % 2 === 0
              ? ChatMessageAuthor.Bot
              : ChatMessageAuthor.User,
          botId: 1,
          botUser: {
            id: 1,
            firstName: 'Bot',
            lastName: 'User',
          },
          content: {
            text: "that's a nice bot",
            stickerId: 'sticker_id',
            images: [],
            keyboard: [],
          },
          sentAt: '2024-09-17T12:51:20.480109Z',
        },
      ],
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  addFeedback(feedbackId: number, feedback: FeedbackAdminResp): Observable<Feedback> {
    return of({
      id: feedbackId,
      botId: 1,
      adminUserEmail: null,
      status: FeedbackStatus.Processed,
      receivedAt: new Date().toISOString(),
      items: [
        {
          id: 1,
          author:
            feedbackId % 2 === 0
              ? ChatMessageAuthor.Bot
              : ChatMessageAuthor.User,
          botId: 1,
          botUser: {
            id: 1,
            firstName: 'Bot',
            lastName: 'User',
          },
          content: {
            text: "that's a nice bot",
            stickerId: 'sticker_id',
            images: [],
            keyboard: [],
          },
          sentAt: '2024-09-17T12:51:20.480109Z',
        },
      ],
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  patchFeedback(feedbackId: number, status: FeedbackStatus): Observable<Feedback> {
    return of({
      id: feedbackId,
      botId: 1,
      adminUserEmail: null,
      status: status,
      receivedAt: new Date().toISOString(),
      items: [
        {
          id: 1,
          author:
            feedbackId % 2 === 0
              ? ChatMessageAuthor.Bot
              : ChatMessageAuthor.User,
          botId: 1,
          botUser: {
            id: 1,
            firstName: 'Bot',
            lastName: 'User',
          },
          content: {
            text: "that's a nice bot",
            stickerId: 'sticker_id',
            images: [],
            keyboard: [],
          },
          sentAt: '2024-09-17T12:51:20.480109Z',
        },
      ],
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }
}
